module.exports = __webpack_public_path__ + "static/media/bg-bottom.b9b61425.png";